import React, { ReactNode } from 'react';
import styles from './PropertyRow.module.css';

interface PropertyRowProps {
  label: string;
  value: string | number | ReactNode;
  variant?: 'default' | 'emphasized';
  tooltip?: string;
}

/**
 * PropertyRow - Simple property/value display pair
 * Used in item detail panels to show properties in a consistent format
 */
export const PropertyRow: React.FC<PropertyRowProps> = ({
  label,
  value,
  variant = 'default',
  tooltip
}) => {
  return (
    <div
      className={`${styles.propertyRow} ${variant === 'emphasized' ? styles.emphasized : ''}`}
      title={tooltip}
    >
      <dt className={styles.label}>{label}:</dt>
      <dd className={styles.value}>{value}</dd>
    </div>
  );
};
